import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, NgZone, Renderer } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BookingService } from './booking.service';
import { submitData } from './submitData';
import { sendData, ConfirmData } from './sendData';
import { environment } from '../../../environments/environment';

import { ToastrService } from 'ngx-toastr';
import { DetailsService } from '../details.service';
import {INgxMyDpOptions, IMyDateModel, IMyDate} from 'ngx-mydatepicker';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.css']
})
export class BookingComponent implements OnInit {
  dateChoosen: boolean;
  airportChoosen: boolean;
  priceForSingle: string;
  priceForSingle1: string;
  priceForDouble: string;
  priceForDouble1: string;
  minPriceSingle: any;
  minPriceDouble: any;

  // lowest price room type index
  lowestPriceIndex: number;

  // test calculations
  airportObject: any;
  boardTypeObject: any;

  // number of times booking have been sent
  countSentBookings = 0;

// comfirm data
  confirmData: ConfirmData;

  firstBoardType: any;
  womanCode: any;
  manCode: any;

  apiUrl = environment.apiBaseUrl;
  // TODO bogdan: replace this with tenant code from sessionData
  defaultTenant;
  productId: any;
  code: any;
  sendData: sendData;
  id: number;
  private sub: any;

  data: any;
  err: string;
  isErr: boolean = false;

  longText: string;
  subText1: string;
  subText2: string;
  shortText: string;
  header: string;
  subHeader: string;

  imgSrc1;

  SingleRoom: any;
  DoubleRoom: any;

  flightFrom;
  boardUpgrades;
  room: number = 0;

  // category from object
  category;

  //validation
  chosenDate: number = 0;

  // test case for un selected prices
  dateID: number;
  priceID: number;
  roomPrice: number;

  boardType = 99999;
  airport: number;

  flightPrice = 0;
  boardPrice = 0;
  flightChanged: boolean = false;

  money: string = '0';
  money2: string = '0';
  roomTypes;

  numberOfParticipiants: number = 2;

  salutations: any;
  countries: any;
  man: string;
  woman: string;
  salutationErr: any;

  date:Date;

  //all data to be sent when form is submitted
  // termsAndConditions: boolean = false;
  submitData: submitData;

  test;
  test1;

  // translations
  error ="Error occured please try again"
  noSpecifiedOffer = "No specified offer"
  bookingSuccess =  "'Have fun!', 'Booking sent!'"
  bookingError ="'Booking error!', 'Didnt send!'"

  myOptions: INgxMyDpOptions = {
    // other options...
    dateFormat: 'dd.mm.yyyy',
  };

  constructor(private router: Router,
      private route: ActivatedRoute,
      private bookingService: BookingService,
      private detailsService: DetailsService,
      private ref: ChangeDetectorRef,
      private zone: NgZone,
      private toastr: ToastrService,
      private renderer: Renderer,
      private translate: TranslateService
      ) {}

  ngOnInit() {
    window.scrollTo(0, 0);
    let temp = localStorage.getItem('sessionData');
    let sessionData = JSON.parse(temp);

    this.defaultTenant = sessionData.tenantCode;

      this.sub = this.route.params.subscribe(params => {
       this.id = +params['id']; // (+) converts string 'id' to a number
    });


    this.translate.getTranslation(this.translate.currentLang).subscribe(
      done => {
         this.bookingSuccess = done['bookingPage'].success;
         this.error = done['commonTranslations'].error;
         this.bookingError = done['bookingPage'].error;
         this.noSpecifiedOffer = done['commonTranslations'].noSpecifiedOffer;
      });



this.date =  new Date();

    this.bookingService.getSalutations().subscribe(
      data => {
        this.salutations = data.salutations;
        this.man = data.salutations[0].name;
        this.woman = data.salutations[1].name;
        this.manCode = data.salutations[0].code;
        this.womanCode = data.salutations[1].code;
        this.submitData.salutationB = null;
        this.submitData.salutation = null;
        this.submitData.salutation1 = null;
        this.zone.run(() => this.man = data.salutations[0].name);
      } ,
      err => this.salutationErr = err,
      () => console.log('done')
    );

    this.bookingService.getCountries().subscribe(
      data => {
        this.countries = data.countries;
      },
      err => console.log(err),
      () => console.log('done')
    );

    // init of fields
    this.submitData = {
      date: '',
      roomType: '',
      airport: '',
      boardType: '',
      salutation: '',
      firstName: '',
      lastName: '',
      dateBirth: '',
      salutation1: '',
      firstName1: '',
      lastName1: '',
      dateBirth1: '',
      salutationB: '',
      firstNameB: '',
      lastNameB: '',
      street: '',
      streetNum: '',
      zip: '',
      city: '',
      country: 'DE',
      phone: '',
      email: '',
      checked: false
    };

    // init of data which will be sent to API
    this.sendData = {
      product: null,
      code: '',
      backLink: '',
      start: '',
      fromAirport: '',
      roomType: '',
      boardType: '',
      customer: {
        salutation: '',
        firstName: '',
        lastName: '',
        street: '',
        streetNumber: '',
        country: '',
        zip: '',
        city: '',
        phone: '',
        email: '',
      },
      participants: [{
        salutation: '',
        firstName: '',
        lastName: '',
        birthday: '',
      },
      {
        salutation: '',
        firstName: '',
        lastName: '',
        birthday: '',
      }
      ]
    };

    if (this.id) {
      this.detailsService.getOfferDetails(this.id).subscribe(
        data => {this.data = data;
          this.code = data.code;
          this.productId = data.id;
          this.longText = data.longText,
          this.sendData.product = this.productId;
          this.sendData.code = this.code,
          this.header = data.header;
          this.subHeader = data.subHeader;
          this.subText1 = data.subText1;
          this.subText2 = data.subText2;
          this.shortText = data.shortText;
          this.category = data.accommodation.category;
          if(this.data.files){
          this.imgSrc1 = this.apiUrl + 'dms/public/' + this.defaultTenant + '/' + this.data.files[0].id;
          }
          // else - mock images to be added
          this.SingleRoom = this.data.accommodation.roomTypes[0].prices;
          this.DoubleRoom = this.data.accommodation.roomTypes[1].prices;
          this.roomTypes = this.data.accommodation.roomTypes;
          this.firstBoardType = data.accommodation.boardTypeName;

          if (typeof this.SingleRoom !== 'undefined') {
        for (let s of this.SingleRoom) {
          let price = s.price;
          s.pricee = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price/100);
        }
      }

        if (typeof this.DoubleRoom !== 'undefined') {
        for (let d of this.DoubleRoom) {
          let price = d.price
          d.pricee = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price/100);
        }
      }

        this.flightFrom = this.data.flight.fromAirports;
        console.log();

        if (typeof this.flightFrom !== 'undefined') {
        for (let f of this.flightFrom){
          let price = f.price
          f.pricee = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price/100);
        }
      }

        this.boardUpgrades = this.data.accommodation.boardUpgrades;
        if (typeof this.boardUpgrades !== 'undefined') {
        for (let f of this.boardUpgrades){
          let price = f.price
          f.pricee = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price/100);
        }
      }

        this.calculateMinPrice();
    },
      err => {this.err = "Unexpected error occured, status" + err.status, this.isErr = true;
      this.toastr.error(this.error);
       this.router.navigate(['']);
      },
        () => console.log("complete")
        ); }else {
            this.err = this.noSpecifiedOffer,
            this.isErr = true;
            this.toastr.error(this.error);
            this.router.navigate(['']);
       }
  }// end of ngOnInit

    back() {
        this.sub = this.route.params.subscribe(params => {
        this.id = +params['id']; // (+) converts string 'id' to a number
        this.router.navigate(['/details', this.id]);
          });
      }

      checkFlight(){
        console.log(this.airport)
      }

    totalPrice() {
      if (this.lowestPriceIndex === 1) {
        let totalprice = this.boardPrice + this.flightPrice + this.roomPrice;
        let price = totalprice;
        let pricefor2 = totalprice * 2;
        let priceForSingle = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price / 100);
        let priceForSingle1 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price / 100);
        this.zone.run(() => this.priceForSingle = priceForSingle);
        this.zone.run(() => this.priceForSingle1 = priceForSingle1);
        this.ref.detectChanges();
      }else {
          // tslint:disable-next-line:max-line-length
          let totalprice = this.boardPrice + this.flightPrice + this.roomPrice;
          let price = totalprice;
          let pricefor2 = totalprice * 2;
          // tslint:disable-next-line:max-line-length
          let priceForDouble1 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( pricefor2  / 100);
          this.zone.run(() => this.priceForDouble1 = priceForDouble1);
          let priceForDouble = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( price / 100);
          this.zone.run(() => this.priceForDouble = priceForDouble);
          this.lowestPriceIndex = 2;
          this.ref.detectChanges();
      }
        }


        updateDoublePrices(){
          // tslint:disable-next-line:max-line-length
          let priceForDouble1 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(( this.minPriceDouble * 2) / 100);
          this.zone.run(() => this.priceForDouble1 = priceForDouble1);
          let priceForDouble = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( this.minPriceDouble / 100);
          this.zone.run(() => this.priceForDouble = priceForDouble);
          this.lowestPriceIndex = 2;
          this.ref.detectChanges();
        }

        updateSinglePrices(){
          let priceForSingle1 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( this.minPriceSingle / 100);
          this.zone.run(() => this.priceForSingle1 = priceForSingle1);
          let priceForSingle = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( this.minPriceSingle / 100);
          this.zone.run(() => this.priceForSingle = priceForSingle);
          this.lowestPriceIndex = 1;
          this.ref.detectChanges();
        }

        // test for calculating min price
        calculateMinPrice(){
          this.minPriceSingle = this.SingleRoom[0].price;
          this.minPriceDouble = this.DoubleRoom[0].price;
          if (typeof this.DoubleRoom !== 'undefined') {
            for (let d of this.DoubleRoom) {
              if (d.price <  this.minPriceDouble) {
                this.minPriceDouble = d.price;
              }
            }
          }
          if (typeof this.SingleRoom !== 'undefined') {
            for (let s of this.SingleRoom) {
              if(s.price < this.minPriceSingle){
                this.minPriceSingle = s.price;
              }
            }
          }
          if ( this.minPriceDouble <  this.minPriceSingle) {
            this.updateDoublePrices();
            this.roomPrice = this.minPriceDouble;

          }else {
            this.updateSinglePrices();
            this.roomPrice = this.minPriceSingle;
          }
        }

      selectFlight(id: number) {
        let prc = this.flightFrom[id].price
        this.flightPrice = prc;
        this.airport = id;

        this.airportChoosen = true;
      }

      selectBoardType(id: number) {
        this.flightChanged = true;
        if (id != 99999) {
        let prc = this.boardUpgrades[id].price
        this.boardPrice = prc;
        this.boardType = id;
        }else{
          this.boardPrice = 0;
        }
      }

      selectedDate(id){
        this.dateID = id;
        this.dateChoosen = true;
      }



      priceIndex(id) {
        this.numberOfParticipiants = id + 1;
        if (id === 0) {
          this.updateSinglePrices();
          if (this.dateID > this.SingleRoom.length - 1) {
            if(this.dateID !== undefined){
              this.dateID = 0;
              this.roomPrice = this.SingleRoom[this.dateID].price;
              this.totalPrice();
            }else{
              this.roomPrice = this.minPriceSingle;
            }
          }else {
            if(this.dateID !== undefined){
            this.roomPrice = this.SingleRoom[this.dateID].price;
            this.totalPrice();
            }else{
              this.roomPrice = this.minPriceSingle;
            }
          }
      }
      if (id === 1) {
        // tslint:disable-next-line:max-line-length
       this.updateDoublePrices();
        if(this.dateID > this.DoubleRoom.length - 1){
          if(this.dateID !== undefined){
          this.dateID = 0;
          this.roomPrice = this.DoubleRoom[this.dateID].price;
          this.totalPrice()
          }else{
            this.roomPrice = this.minPriceDouble;
          }
        }else {
          if(this.dateID !== undefined){
          this.roomPrice = this.DoubleRoom[this.dateID].price;
          this.totalPrice()
          }else{
            this.roomPrice = this.minPriceDouble;
          }
        }
        }
        this.priceID = id;
      }

      toggleChekbox() {
        this.submitData.checked = !this.submitData.checked;
      }

      // send all data to API
        toggleSubmitAllData() {
          this.sendData.product = this.productId;
          this.sendData.code = this.code;
          this.sendData.backLink = sessionStorage.getItem('backLink');
          this.sendData.start = this.SingleRoom[this.dateID].start;
          this.sendData.roomType = this.roomTypes[this.priceID].roomType;
          this.sendData.fromAirport = this.flightFrom[this.airport].airport;
          if (this.boardType === 99999) {
            this.sendData.boardType = this.data.accommodation.boardType;
          }else {
          this.sendData.boardType = this.boardUpgrades[this.boardType].boardType;
          }
          this.sendData.customer.salutation = this.submitData.salutationB;
          this.sendData.customer.firstName = this.submitData.firstNameB;
          this.sendData.customer.lastName = this.submitData.lastNameB;
          this.sendData.customer.street = this.submitData.street;
          this.sendData.customer.streetNumber = this.submitData.streetNum;
          this.sendData.customer.country = this.submitData.country;
          this.sendData.customer.zip = this.submitData.zip;
          this.sendData.customer.city = this.submitData.city;
          this.sendData.customer.phone = this.submitData.phone;
          this.sendData.customer.email = this.submitData.email;

          this.sendData.participants[0].salutation = this.submitData.salutation;
          this.sendData.participants[0].firstName = this.submitData.firstName;
          this.sendData.participants[0].lastName = this.submitData.lastName;
          this.sendData.participants[0].birthday = this.submitData.dateBirth;

          if (this.numberOfParticipiants === 2) {
              this.sendData.participants[1].salutation = this.submitData.salutation1;
          this.sendData.participants[1].firstName = this.submitData.firstName1;
          this.sendData.participants[1].lastName = this.submitData.lastName1;
          this.sendData.participants[1].birthday = this.submitData.dateBirth1;

        }else {
          this.sendData.participants.splice(1, 2);
        }
        this.bookingService.sendDataToApi(this.sendData).subscribe(
          data => {
            this.confirmData = {} as ConfirmData;
            this.confirmData.flight =  {
              fromAirport: '',
              toAirport: ''
            },
            this.confirmData.type = data.bookingType;
            this.confirmData.customers = data.customerLines;
            this.confirmData.totalPriceString = data.totalPriceString;
            this.confirmData.travelPeriod = data.travelPeriod;
            this.confirmData.flight.toAirport = data.flight.toAirport;
            this.confirmData.flight.fromAirport = data.flight.fromAirport;
            this.confirmData.participants = new Array();
            for (let participant of data.participants){
              this.confirmData.participants.push({
                  salutation: participant.salutation,
                  firstName: participant.firstName,
                  lastName: participant.lastName,
                  birthdayAsString: participant.birthdayAsString
              });
            }
            document.getElementById('open-modal-booking').click();
            this.countSentBookings++;
          },
          err => { console.log(err), this.toastr.error(this.bookingError); } ,
          () => this.toastr.success(this.bookingSuccess)
          );
        }

      // open t&c in new window
      openInNewTab(url) {
        var win = window.open(url, '_blank');
        win.focus();
      }

      onCalendarToggle(event: number): void {}

      onDateChanged($event, birth) {
        console.log(birth)
        let dateArray = $event.formatted.split('.');
        this.submitData[birth] = dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
        console.log(this.submitData)
      }

}



// WEBPACK FOOTER //
// ./src/app/details/booking/booking.component.ts